








































import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import { Order } from '@/interfaces/order.interface';
import OrderDetailsFields from '@/components/OrderDetailsFields.vue';
import OrderDetailsDocuments from '@/components/OrderDetailsDocuments.vue';
import OrderDetailsQuotes from '@/components/OrderDetailsQuotes.vue';
import OrderDetailsComments from '@/components/OrderDetailsComments.vue';
import OrderDetailsHistory from '@/components/OrderDetailsHistory.vue';

@Component({
    components: {
        OrderDetailsFields,
        OrderDetailsDocuments,
        OrderDetailsQuotes,
        OrderDetailsComments,
        OrderDetailsHistory
    }
})
export default class OrderDetails extends Vue {
    @Prop({default: []}) order!: Order;
}
